import * as React from 'react';
import { getValue, Row } from '../Row';
import { useSelector } from 'react-redux';
import { selectCurrentBet, selectIsAuctionEnabled } from '../../../../selectors/auction';

export const AuctionContainer = () => {
  const bet = useSelector(selectCurrentBet);
  const isAuctionEnabled = useSelector(selectIsAuctionEnabled);

  if (!isAuctionEnabled || !bet) {
    return null;
  }

  const priceValue = getValue({ price: bet });

  return <Row name="Ставка" value={priceValue} />;
};
